import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { SponsorBlockInterface } from '~/types/AppData/PageBuilder/SponsorBlockInterface';

export default component$<SponsorBlockInterface['props']>(
  ({ image, text, url, target }): JSX.Element => {
    const { imageURL, altText } = image;

    return (
      <a
        href={url}
        target={target}
        class='bg-black py-2.5 px-4 flex items-center justify-center gap-2'
      >
        <span class='text-white'>{text}</span>
        {imageURL ? (
          <img
            alt={altText}
            src={imageURL}
            width={96}
            height={undefined}
            class='max-w-[96px] w-full'
          />
        ) : null}
      </a>
    );
  }
);
